<template>
  <v-stepper v-model="stepNum">
    <v-stepper-header>
      <v-stepper-step :complete="stepNum > 1" step="1">Caratteristiche Personali</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="stepNum > 2" step="2">Presentazione Sintomi</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <TipologiaUtente
          @user-type-added="stepNum = 2"
          @user-type-cancel="$emit('user-added-cancel')"
          :user.sync="user"
        />
      </v-stepper-content>
      <v-stepper-content step="2">
        <PresentazioneSintomatica
          @user-pre-added="onComplete"
          @user-pre-cancel="stepNum = stepNum - 1"
          :user.sync="user"
        />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
// @ is an alias to /src
import PresentazioneSintomatica from "@/components/PresentazioneSintomatica";
import TipologiaUtente from "@/components/TipologiaUtente";
export default {
  name: "AddUser",
  components: {
    PresentazioneSintomatica,
    TipologiaUtente
  },
  data: () => ({
    stepNum: 1,
    user: { nickname: "" }
  }),
  methods: {
    onComplete() {
      /*
      this.user.nickname = this.user.nickname.trim();
      if (!this.user.nickname.length) {
        this.stepNum = 1;
        return;
      }
      */
      const user = this.user;
      this.$emit("user-added", user);
      this.user = { nickname: "" };
      this.stepNum = 1;
    }
  }
};
</script>
